
import EditComponent from "../../../components/events/Edit.vue";

export default {
  components: {
    EditComponent
  }
}
